import React from 'react'

import {FaSpinner} from 'react-icons/fa'


export function setCookie(name,value,days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}
export function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)===' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
}
export function eraseCookie(name) {   
    document.cookie = name+'=; Max-Age=-99999999;';  
}

export function dbProvider11(opts) {
    let _opts ={    url:"",    pathParam:"",    queryParam:{} , method:'get', data:[]};
    _opts = {..._opts, opts};
    _opts = Object.assign({}, _opts, opts);  
    var queryString;
    if (opts.queryParam !=={}){
      queryString = Object.keys(_opts.queryParam).map(key => encodeURIComponent(key) + '=' + encodeURIComponent(_opts.queryParam[key])).join('&');
    }
    let href = "";
    href = window.location.href.split('/');
    href = href[href.length-1];
    if (href==='') {
      href = "---"
    }
    
    var url = _opts.url 
    if (_opts.pathParam !=="") {
        url = url + "/" + _opts.pathParam 
    }
    if (queryString !== "" ) {
        url = url + "?" + queryString
    }
    url = `${process.env.REACT_APP_API_URL}/${url}`
    let errorOccured = false;
    const secret = getCookie("secret");
    return fetch(url, {
      method: _opts.method,
      cache: 'no-cache', 
      headers: {authorization: secret, "module-name": href ,  'Content-Type': 'application/json', },
      redirect: 'follow',
      referrer: 'no-referrer',
      body: JSON.stringify(opts.data)
    }).then(response => {
      if (!response.ok) {
        errorOccured = true;
        return response.text()
      } else {
        return response
      }
    }).then(response => {
      if (errorOccured) {
        throw new Error(response);
      }
      return response.json()
    })
  }

export function Spinner(props) {
  return (
    <FaSpinner className="spinner " />
  )
}

export function FullPageSpinner(showSpinner) {
  return (
    <div id="fullpage-spinner">
      <div className="spinner-overlay">
      </div>
      <div className="fullpage-spinner" >
        <div className="spinner-wrapper">
          <Spinner />
        </div>
      </div>
    </div>
  )
}

export function ErrorBox(content) {
  document.getElementById("error-box").style.visibility ="visible"
  document.getElementById("eb-message").innerHTML = content
}



/*	This work is licensed under Creative Commons GNU LGPL License.

	License: http://creativecommons.org/licenses/LGPL/2.1/
   Version: 0.9
	Author:  Stefan Goessner/2006
	Web:     http://goessner.net/ 
*/
